<template>
  <div id="sign-in-email" class="container">
    <b-field label="メールアドレス" :type="emailInputClass">
      <b-input type="email" v-model="email"></b-input>
    </b-field>
    <b-field label="パスワード" :type="passwordInputClass">
      <b-input type="password" v-model="password" password-reveal></b-input>
    </b-field>
    <div class="button__wrap">
      <b-button @click="signIn" class="button__grad">
        入店する
      </b-button>
    </div>
  </div>
</template>

<script>
import { auth } from '@/plugins/firebase';
import * as authServices from '@/services/authServices';

export default {
  name: 'SingInEmail',
  data() {
    return {
      email: '',
      password: '',
      emailInputClass: '',
      passwordInputClass: ''
    };
  },
  methods: {
    async signIn() {
      try {
        let result = await auth.signInWithEmailAndPassword(this.email.trim(), this.password);
        await authServices.setSigninDateTime(result.user.uid);
        this.$router.push(this.$route.path === '/email-confirmed' ? '/movie' : '/home');
      } catch (err) {
        let message =
          'ログインできなくなっています。しばらく経ってからまたお試しください。';

        switch (err.code) {
          case 'auth/invalid-email':
            message = 'メールのフォーマットが間違っています。';
            break;
          case 'auth/user-disabled':
            message = 'ユーザーが無効化されました。';
            break;
          case 'auth/user-not-found':
            message = 'ユーザーが存在していません。';
            break;
          case 'auth/wrong-password':
            message = 'パスワードが間違っています。';
            break;
          case 'auth/too-many-requests':
            message =
              'ログイン失敗の回数の上限に達しました。しばらく経ってからまたお試しください。';
            break;
        }

        this.emailInputClass = 'is-danger';
        this.passwordInputClass = 'is-danger';

        this.$buefy.toast.open({
          duration: 3500,
          message: message,
          type: 'is-danger'
        });
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
